import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const PaymentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0;
`

export const PaymentHeader = styled.div`
  display: flex;
  align-items: center;
`

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  background: ${Colors.Neutral10};
  border-radius: 20px;
  cursor: pointer;
  border: 0;
  color: ${Colors.Neutral50};
  ${Typography.Caption};
  font-weight: ${FontWeights.DemiBold};
  padding: 4px 16px 4px 8px;
  transition: all 0.2s ease;

  &:hover {
    background: ${Colors.Neutral20};
    color: ${Colors.Neutral90};
  }
`

export const TotalSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 18px;
  margin-bottom: 32px;

  ${Media.Phone`
    margin-top: 16px;
    margin-bottom: 24px;
  `};
`

export const TotalLabel = styled.span`
  ${Typography.Subhead};
  color: ${Colors.Neutral90};
`

export const TotalAmount = styled.span`
  ${Typography.Subhead};
  color: ${Colors.Neutral90};
`

export const PaymentMethodsContainer = styled.div<{ $isLoading: boolean }>`
  flex: 1;
  overflow-y: auto;
  max-height: 600px;
  padding-left: 5px;
  padding-right: 4px;

  ${props =>
    props.$isLoading &&
    `
    padding: 0 140px;
    display: flex;
    align-items: center;
  `}

  ${Media.Tablet`
    max-height: 500px;
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
  `};

  ${Media.Phone`
    padding: 0;
    max-height: calc(100vh - 200px);
    max-width: 100%;
  `}

  max-width: 400px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${Colors.Neutral10};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${Colors.Neutral40};
    border-radius: 3px;

    &:hover {
      background: ${Colors.Neutral50};
    }
  }
`

export const DropinContainer = styled.div`
  width: 100%;
  min-height: 400px;

  ${Media.Tablet`
    min-height: 300px;
  `};

  ${Media.Phone`
    min-height: 250px;
  `};

  .adyen-checkout__dropin {
    background: transparent;
    padding: 0 !important;
    margin: 0 !important;
    --adyen-sdk-color-label-primary: #828ba2;
    --adyen-sdk-color-label-critical: #fb4458;
    --adyen-sdk-color-outline-critical: #fb4458;
    --adyen-sdk-color-background-critical-strong: #fb4458;
    --adyen-sdk-color-background-always-dark: #1a91f0;
    --adyen-sdk-color-background-always-dark-active: #10529b;
    --adyen-sdk-color-background-inverse-primary-hover: #1170cd;
    --adyen-sdk-text-subtitle-font-size: 20px;
    --adyen-sdk-text-title-font-size: 20px;
  }

  .adyen-checkout__payment-method {
    border: none;
    margin-bottom: 0;
    padding: 0;
    background: transparent;
    margin-left: 0 !important;
    padding-left: 0 !important;
  }

  .adyen-checkout__payment-method__header {
    padding: 0;
    margin-left: 0 !important;
    padding-left: 0 !important;
    display: flex !important;
    align-items: center;
    gap: 12px;
  }

  .adyen-checkout__payment-method:first-child .adyen-checkout__payment-method__radio,
  .adyen-checkout__payment-method--scheme .adyen-checkout__payment-method__radio,
  .adyen-checkout__payment-method[data-type='scheme'] .adyen-checkout__payment-method__radio {
    display: block !important;
    visibility: visible !important;
    width: 20px;
    height: 20px;
    border: 2px solid ${Colors.Neutral30};
    border-radius: 50%;
    margin: 0 12px 0 0 !important;
    padding: 0 !important;
    flex-shrink: 0;
    position: relative !important;
    left: 0 !important;
    transform: translateX(0) !important;

    &:checked {
      border-color: ${Colors.Blue50};
      background-color: ${Colors.Blue50};
    }
  }

  .adyen-checkout__payment-method__name {
    ${Typography.L};
    font-weight: ${FontWeights.Medium};
    color: ${Colors.Neutral90};
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .adyen-checkout__payment-method:first-child .adyen-checkout__payment-method__name {
    font-size: 1em !important;
  }

  .adyen-checkout__card__form {
    padding: 0 !important;
    margin: 0 !important;
    margin-left: 0 !important;
    padding-left: 0 !important;
    transform: translateX(0) !important;
    left: 0 !important;
    position: relative !important;
  }

  .adyen-checkout__field {
    margin-bottom: 8px;
    margin-left: 0 !important;
    padding-left: 0 !important;
  }

  .adyen-checkout__field--50 {
    width: 48%;
    display: inline-block;
    vertical-align: top;

    &:first-of-type {
      margin-right: 4%;
    }
  }

  .adyen-checkout__field[data-cse='encryptedExpiryDate'],
  .adyen-checkout__field[data-cse='encryptedSecurityCode'] {
    width: 48%;
    display: inline-block;
    vertical-align: top;

    &:first-of-type {
      margin-right: 4%;
    }
  }

  .adyen-checkout__card__exp-date,
  .adyen-checkout__card__cvc {
    width: 48%;
    display: inline-block;
    vertical-align: top;

    &:first-of-type {
      margin-right: 4%;
    }
  }

  .adyen-checkout__label__text {
    color: var(--adyen-sdk-color-label-primary, #00112c);
    display: block;
    font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
    font-weight: var(--adyen-sdk-text-body-font-weight, 400);
    line-height: var(--adyen-sdk-text-body-line-height, 20px);
    margin-bottom: var(--adyen-sdk-spacer-020, 4px);
    visibility: visible !important;
  }

  .adyen-checkout-contextual-text,
  .adyen-checkout-contextual-text--error {
    align-items: center;
    color: var(--adyen-sdk-color-label-primary, #00112c);
    display: flex;
    font-size: var(--adyen-sdk-text-caption-font-size, 0.75rem);
    font-weight: var(--adyen-sdk-text-body-font-weight, 400);
    line-height: var(--adyen-sdk-text-caption-line-height, 18px);
    margin-top: var(--adyen-sdk-spacer-020, 4px);
    opacity: 1;
    transition: margin 0.2s ease-out, opacity 0.2s ease-out;
  }

  .adyen-checkout__input-wrapper {
    background: ${Colors.Neutral10};
    border: 0;
    border-bottom: 2px solid transparent;
    border-radius: 2px;
    padding: 0;
    transition: border 0.2s ease-out, box-shadow 0.2s ease-out;
  }

  .adyen-checkout__input {
    background: transparent;
    border: none;
    padding: 8px 16px;
    ${Typography.Body};
    color: ${Colors.Neutral90};
    width: 100%;
    height: 40px;
    line-height: 20px;
    display: flex;
    align-items: center;

    &::placeholder {
      color: ${Colors.Neutral40};
      font-weight: ${FontWeights.Regular};
      opacity: 0.6;
      line-height: 20px;
    }

    &:focus {
      outline: none;
    }
  }

  .adyen-checkout__input-wrapper:hover,
  .adyen-checkout__input-wrapper:active,
  .adyen-checkout__input-wrapper:active:hover,
  .adyen-checkout__input-wrapper:focus-within,
  .adyen-checkout__input-wrapper:focus-within:hover,
  .adyen-checkout__label--focused + .adyen-checkout__input-wrapper {
    box-shadow: none;
    border: 0;
    border-bottom: 2px solid #1a91f0;
  }

  .adyen-checkout__field--error .adyen-checkout__input-wrapper {
    border: 0;
    border-bottom: 2px solid var(--adyen-sdk-color-outline-critical, #fb4458);
  }

  .adyen-checkout__field--error .adyen-checkout__label__text {
    color: var(--adyen-sdk-color-label-critical, #fb4458) !important;
  }

  /* Hide danger/error icons */
  .adyen-checkout__field--error .adyen-checkout__icon,
  .adyen-checkout__field--error .adyen-checkout__input__icon,
  .adyen-checkout__field--error [class*='icon'],
  .adyen-checkout__field--error svg,
  .adyen-checkout__input-wrapper--error .adyen-checkout__icon,
  .adyen-checkout__input-wrapper--error svg {
    display: none !important;
  }

  /* Hide inline validation span that causes layout issues */
  .adyen-checkout-input__inline-validation.adyen-checkout-input__inline-validation--invalid {
    display: none !important;
  }

  .adyen-checkout__field__error-text,
  .adyen-checkout__field--error .adyen-checkout-contextual-text,
  .adyen-checkout__field--error .adyen-checkout-contextual-text--error,
  .adyen-checkout-input__inline-validation,
  .adyen-checkout__field--error .adyen-checkout__field__error-text,
  .adyen-checkout__field--error .adyen-checkout__input__inline-validation,
  .adyen-checkout__field--error .adyen-checkout__error-text,
  .adyen-checkout__field--error [class*='contextual'],
  .adyen-checkout__field--error [class*='error-text'],
  .adyen-checkout__field--error [class*='inline-validation'] {
    color: var(--adyen-sdk-color-label-critical, #fb4458) !important;
    font-size: var(--adyen-sdk-text-caption-font-size, 0.75rem);
    font-weight: var(--adyen-sdk-text-body-font-weight, 400);
    line-height: var(--adyen-sdk-text-caption-line-height, 18px);
    margin-top: var(--adyen-sdk-spacer-020, 4px);
  }

  .adyen-checkout-form-instruction {
    display: none !important;
  }

  .adyen-checkout__card__brands {
    display: none !important;
  }

  .adyen-checkout__field[data-cse='encryptedCardNumber'] .adyen-checkout__card__brands {
    display: flex !important;
    gap: 4px;
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
  }

  .adyen-checkout__field[data-cse='encryptedCardNumber'] {
    position: relative;
  }

  .adyen-checkout__field[data-cse='encryptedCardNumber'] .adyen-checkout__input {
    padding-right: 120px;
  }

  .adyen-checkout__field--cardNumber .adyen-checkout__card__brands,
  .adyen-checkout__card__cardNumber__input .adyen-checkout__card__brands {
    display: flex !important;
    gap: 4px;
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
  }

  .adyen-checkout__button--pay {
    display: none !important;
  }

  .adyen-checkout__fieldset__title {
    color: #1e2532 !important;
  }

  .adyen-checkout-pm-details-wrapper {
    width: 100%;
  }

  .adyen-checkout__dropin {
    display: block;
    position: static;
    padding: 0 !important;
    margin: 0 !important;
  }

  .adyen-checkout__dropin > *,
  .adyen-checkout__dropin .adyen-checkout__payment-methods,
  .adyen-checkout__dropin .adyen-checkout__payment-method-list {
    padding-left: 0 !important;
    margin-left: 0 !important;
  }

  .adyen-checkout__payment-methods-list {
    gap: 48px;
  }

  .adyen-checkout__payment-method:not(:first-child) {
    background: transparent;
    border: none;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .adyen-checkout__applepay__button,
  .adyen-checkout__googlepay__button,
  .adyen-checkout__paypal__button {
    width: 100%;
    border-radius: 8px;
    height: 48px;
    border: none;
  }

  .adyen-checkout__payment-method:not(:first-child) .adyen-checkout__payment-method__header {
    margin-bottom: 0;
    padding: 0;
    width: 100%;
  }

  .adyen-checkout__payment-method:not(:first-child) .adyen-checkout__payment-method__name {
    ${Typography.Body};
    font-weight: ${FontWeights.Medium};
    color: ${Colors.Neutral90};
    margin: 0;
  }

  .adyen-checkout__payment-method--googlepay .adyen-checkout__payment-method__radio,
  .adyen-checkout__payment-method[data-type='paywithgoogle'] .adyen-checkout__payment-method__radio,
  .adyen-checkout__payment-method--paywithgoogle .adyen-checkout__payment-method__radio,
  .adyen-checkout__payment-method--applepay .adyen-checkout__payment-method__radio,
  .adyen-checkout__payment-method[data-type='applepay'] .adyen-checkout__payment-method__radio {
    display: block !important;
    visibility: visible !important;
    width: 20px;
    height: 20px;
    border: 2px solid ${Colors.Neutral30};
    border-radius: 50%;
    margin-right: 12px;
    flex-shrink: 0;
    position: relative;

    &:checked {
      border-color: ${Colors.Blue50};
      background-color: ${Colors.Blue50};
    }
  }

  .adyen-checkout__payment-method--googlepay .adyen-checkout__payment-method__header,
  .adyen-checkout__payment-method[data-type='paywithgoogle']
    .adyen-checkout__payment-method__header,
  .adyen-checkout__payment-method--paywithgoogle .adyen-checkout__payment-method__header,
  .adyen-checkout__payment-method--applepay .adyen-checkout__payment-method__header,
  .adyen-checkout__payment-method[data-type='applepay'] .adyen-checkout__payment-method__header {
    display: flex !important;
    align-items: center;
    gap: 12px;
    justify-content: flex-start;
    padding-left: 0 !important;
    margin-left: 0 !important;
  }

  .adyen-checkout__payment-method--googlepay,
  .adyen-checkout__payment-method[data-type='paywithgoogle'],
  .adyen-checkout__payment-method--paywithgoogle,
  .adyen-checkout__payment-method[data-type='googlepay'] {
    padding: 0 !important;
    margin: 0 !important;
    text-align: left !important;
    transform: translateX(0) !important;
    position: relative !important;
    left: 0 !important;
  }

  .adyen-checkout__payment-method--googlepay .adyen-checkout__payment-method__radio,
  .adyen-checkout__payment-method[data-type='paywithgoogle'] .adyen-checkout__payment-method__radio,
  .adyen-checkout__payment-method--paywithgoogle .adyen-checkout__payment-method__radio,
  .adyen-checkout__payment-method[data-type='googlepay'] .adyen-checkout__payment-method__radio {
    margin: 0 12px 0 0 !important;
    padding: 0 !important;
    position: relative !important;
    left: 0 !important;
    transform: translateX(0) !important;
  }

  .adyen-checkout__payment-method--applepay .adyen-checkout__payment-method__radio,
  .adyen-checkout__payment-method[data-type='applepay'] .adyen-checkout__payment-method__radio {
    margin: 0 12px 0 0 !important;
    padding: 0 !important;
    position: relative !important;
    left: 0 !important;
    transform: translateX(0) !important;
  }

  .adyen-checkout__payment-method--googlepay .adyen-checkout__payment-method__header,
  .adyen-checkout__payment-method[data-type='paywithgoogle']
    .adyen-checkout__payment-method__header,
  .adyen-checkout__payment-method--paywithgoogle .adyen-checkout__payment-method__header,
  .adyen-checkout__payment-method[data-type='googlepay'] .adyen-checkout__payment-method__header {
    margin: 0 !important;
    padding: 0 !important;
    transform: translateX(0) !important;
    left: 0 !important;
  }

  .adyen-checkout__payment-method--googlepay .adyen-checkout__payment-method__name,
  .adyen-checkout__payment-method[data-type='paywithgoogle'] .adyen-checkout__payment-method__name,
  .adyen-checkout__payment-method--paywithgoogle .adyen-checkout__payment-method__name,
  .adyen-checkout__payment-method[data-type='googlepay'] .adyen-checkout__payment-method__name {
    margin: 0 !important;
    padding: 0 !important;
    transform: translateX(0) !important;
  }

  .adyen-checkout__payment-method--applepay,
  .adyen-checkout__payment-method[data-type='applepay'],
  .adyen-checkout__payment-method--paypal,
  .adyen-checkout__payment-method[data-type='paypal'] {
    display: flex !important;
    background: transparent;
    border: none;
    align-items: center;
    cursor: pointer;
  }

  .adyen-checkout__payment-method--applepay .adyen-checkout__payment-method__radio,
  .adyen-checkout__payment-method[data-type='applepay'] .adyen-checkout__payment-method__radio,
  .adyen-checkout__payment-method--paypal .adyen-checkout__payment-method__radio,
  .adyen-checkout__payment-method[data-type='paypal'] .adyen-checkout__payment-method__radio {
    display: block !important;
    visibility: visible !important;
    width: 20px;
    height: 20px;
    border: 2px solid ${Colors.Neutral30};
    border-radius: 50%;
    margin-right: 12px;
    flex-shrink: 0;

    &:checked {
      border-color: ${Colors.Blue50};
      background-color: ${Colors.Blue50};
    }
  }

  .adyen-checkout__payment-method__details {
    padding: 0 !important;
  }

  .adyen-checkout__payment-method:not(:first-child) .adyen-checkout__payment-method__details {
    display: none;
  }

  .adyen-checkout__payment-method:not(:first-child).adyen-checkout__payment-method--selected
    .adyen-checkout__payment-method__details {
    display: block;
    margin-top: 16px;
    width: 100%;
  }

  .adyen-checkout__payment-method:not(:first-child) {
    flex-direction: column !important;
    align-items: flex-start !important;
  }
`

export const CustomPaymentMethod = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  padding: 16px;
  background: ${Colors.White};
  border: 1px solid ${props => (props.selected ? Colors.Blue50 : Colors.Neutral20)};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 8px;

  &:hover {
    border-color: ${Colors.Blue50};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  ${props =>
    props.selected &&
    `
    border-color: ${Colors.Blue50};
    box-shadow: 0 0 0 3px ${Colors.Blue10};
  `}
`

export const PaymentMethodRadio = styled.input`
  width: 20px;
  height: 20px;
  border: 2px solid ${Colors.Neutral40};
  border-radius: 50%;
  margin-right: 16px;
  flex-shrink: 0;
  appearance: none;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${Colors.Blue50};
  }

  &:checked {
    border-color: ${Colors.Blue50};
    background-color: ${Colors.Blue50};

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: ${Colors.White};
    }
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px ${Colors.Blue10};
  }
`

export const PaymentMethodContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`

export const PaymentMethodLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 32px;
  background: ${Colors.White};
  border: 1px solid ${Colors.Neutral20};
  border-radius: 6px;
  font-size: 16px;
  font-weight: ${FontWeights.Medium};
  color: ${Colors.Neutral70};

  /* Special styling for different payment methods */
  &.apple-pay {
    background: linear-gradient(135deg, #000 0%, #333 100%);
    color: white;
    font-size: 18px;
  }

  &.cards {
    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
    color: white;
  }

  &.google-pay {
    background: linear-gradient(135deg, #4285f4 0%, #34a853 100%);
    color: white;
    font-weight: ${FontWeights.Bold};
  }

  &.paypal {
    background: linear-gradient(135deg, #0070ba 0%, #003087 100%);
    color: white;
    font-weight: ${FontWeights.Bold};
  }
`

export const PaymentMethodName = styled.span`
  ${Typography.Body};
  font-weight: ${FontWeights.Medium};
  color: ${Colors.Neutral90};
`
